import { render, staticRenderFns } from "./replace-phone.vue?vue&type=template&id=02dab9ae&scoped=true&"
import script from "./replace-phone.vue?vue&type=script&lang=js&"
export * from "./replace-phone.vue?vue&type=script&lang=js&"
import style0 from "./replace-phone.vue?vue&type=style&index=0&id=02dab9ae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02dab9ae",
  null
  
)

export default component.exports